export interface VideoMetadata {
    duration?: number;
    width?: number;
    height?: number;
    aspectRatio?: string;
    size?: number;
    mimeType?: string;
}

export interface Media {
    id: string;
    url: string;
    signedUrl?: string;
    type: MediaType;
    dateCreated: Date;
    thumbnail?: string;
    isProcessing?: boolean;
    error?: boolean;
    videoMetadata?: VideoMetadata;
}

export enum MediaType {
    ListingImage = "Listing Image",
    ListingVideo = "Listing Video",
    Promotion = "Promotion",
    AssetImage = "Asset Image",
    AssetVideo = "Asset Video",
}
